<ifbp-dashboard-page-shell [page]="page$ | async" [asOfUtc]="(vm$ | async)?.asOfUtc ?? null">
  <ng-container *ngIf="vm$ | async as vm" [ngSwitch]="vm.state">
    <ifbp-smart-insights-skeleton *ngSwitchCase="VmState.LOADING"></ifbp-smart-insights-skeleton>
    <ifbp-snapshot-error-card *ngSwitchCase="VmState.ERROR" [message]="vm.errorMessage"></ifbp-snapshot-error-card>
    <section class="insights" *ngSwitchCase="VmState.DATA">
      <ul class="insights__rows" role="list" *ngIf="!vm.data?.isEmpty; else empty">
        <li class="insights__row" *ngFor="let row of vm.data?.rows; trackBy: trackByType">
          <ifbp-insight-row [vm]="row"></ifbp-insight-row>
        </li>
      </ul>
      <ng-template #empty>
        <p class="insights__empty">Nothing needs your attention right now.</p>
      </ng-template>
    </section>
  </ng-container>
</ifbp-dashboard-page-shell>
